var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6,39c-4.2,3.1 -10.5,5 -15.6,5c-7.3,0 -13.8,-2.9 -18.8,-7.4c-0.4,-0.4 0,-0.8 0.4,-0.6c5.4,3.1 11.5,4.9 18.3,4.9c4.6,0 10.4,-1 15.1,-3c0.7,-0.2 1.3,0.6 0.6,1.1zM41.1,36.9c-0.5,-0.7 -3.5,-0.3 -4.8,-0.2c-0.4,0 -0.5,-0.3 -0.1,-0.6c2.3,-1.7 6.2,-1.2 6.6,-0.6c0.4,0.6 -0.1,4.5 -2.3,6.3c-0.3,0.3 -0.7,0.1 -0.5,-0.2c0.5,-1.2 1.6,-4 1.1,-4.7z",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,29.8c-1,-1.3 -2,-2.4 -2,-4.9v-8.3c0,-3.5 0,-6.6 -2.5,-9c-2,-1.9 -5.3,-2.6 -7.9,-2.6c-5.5,0 -10.3,2.2 -11.5,8.4c-0.1,0.7 0.4,1 0.8,1.1l5.1,0.6c0.5,0 0.8,-0.5 0.9,-1c0.4,-2.1 2.1,-3.1 4.1,-3.1c1.1,0 3.2,0.6 3.2,3v3c-3.2,0 -6.6,0 -9.4,1.2c-3.3,1.4 -5.6,4.3 -5.6,8.6c0,5.5 3.4,8.2 7.8,8.2c3.7,0 5.9,-0.9 8.8,-3.8c0.9,1.4 1.3,2.2 3,3.7c0.4,0.2 0.9,0.2 1.2,-0.1v0c1,-0.9 2.9,-2.6 4,-3.5c0.5,-0.4 0.4,-1 0,-1.5zM27,22.1v0c0,2 -0.1,6.9 -5,6.9c-3,0 -3,-3 -3,-3c0,-4.5 4.2,-5 8,-5z",
    fill: "#16191a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonIcon);
export default __webpack_public_path__ + "static/media/amazonIcon.a1e1a5b72e1519613b94b1fad3254a4f.svg";
export { ForwardRef as ReactComponent };